import { formatISODateTime } from 'src/utils/formatDate';

export function ScheduledMessagesBox({ data, lastChild = false }) {
  return (
    <div
      className="scheduledMessagesBoxContainer"
      style={
        !lastChild
          ? {
              borderBottom: '1px solid var(--border-dark-secundary)',
              paddingBottom: 16,
            }
          : undefined
      }
    >
      <div className="scheduledMessagesBox">
        <div className="message">
          <p>
            {data?.message_content?.text ?? data?.message_content?.[0]?.text}
          </p>
        </div>
        <div className="details">
          <span>{formatISODateTime(data?.scheduled_at)}</span>
          <div>
            <span>{data?.user?.attributes?.name}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
